
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
    faUser
} from '@fortawesome/free-solid-svg-icons';

import Toaster from '../components/Toaster';
import './Button.css';
import '../global.css';
import '../components/Theme.css';

const Button = () =>{
    return(
        <div className="container mt-6">
            <div className="card">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card-header">
                            <h3 className="h5 mb-0">Button Design</h3>
                        </div>
                        <div className="card-block">
                            <h6>Button Size: btn-sm</h6>
                            <div className="d-flex gap-10">
                                <button class="btn btn-primary btn-sm">Primary</button>
                                <button class="btn btn-secondary btn-sm ml-10">Secondary</button>
                                <button class="btn btn-info btn-sm ml-10">Info</button>
                                <button class="btn btn-warning btn-sm ml-10">Warning</button>
                                <button class="btn btn-danger btn-sm ml-10">Danger</button>
                                <button class="btn btn-success btn-sm ml-10">Success</button>
                                <button class="btn btn-dark btn-sm ml-10">Dark</button>
                                <button class="btn btn-disabled btn-sm ml-10">Disabled</button>
                                <button class="btn btn-white btn-sm ml-10">White</button>
                            </div>

                            <h6 className="mt-4">Button Size: btn-me</h6>
                            <div className="d-flex gap-10">
                                <button class="btn btn-primary btn-me">Primary</button>
                                <button class="btn btn-secondary btn-me ml-10">Secondary</button>
                                <button class="btn btn-info btn-me ml-10">Info</button>
                                <button class="btn btn-warning btn-me ml-10">Warning</button>
                                <button class="btn btn-danger btn-me ml-10">Danger</button>
                                <button class="btn btn-success btn-me ml-10">Success</button>
                                <button class="btn btn-dark btn-me ml-10">Dark</button>
                                <button class="btn btn-disabled btn-me ml-10">Disabled</button>
                                <button class="btn btn-white btn-me ml-10">White</button>
                            </div>

                            <h6 className="mt-4">Button Size: btn-lg</h6>
                            <div className="d-flex gap-10">
                                <button class="btn btn-primary btn-lg">Primary</button>
                                <button class="btn btn-secondary btn-lg ml-10">Secondary</button>
                                <button class="btn btn-info btn-lg ml-10">Info</button>
                                <button class="btn btn-warning btn-lg ml-10">Warning</button>
                                <button class="btn btn-danger btn-lg ml-10">Danger</button>
                                <button class="btn btn-success btn-lg ml-10">Success</button>
                                <button class="btn btn-dark btn-lg ml-10">Dark</button>
                                
                            </div>
                            <div className="d-flex gap-10 mt-3">
                                <button class="btn btn-disabled btn-lg">Disabled</button>
                                <button class="btn btn-white btn-lg">White</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card-header">
                            <h3 className="h5 mb-0">Icon Button Design</h3>
                        </div>
                        <div className="card-block">
                            <h6>Icon Button Size: btn-sm</h6>
                            <div className="d-flex gap-10">
                                <button class="btn btn-primary btn-sm">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Primary        
                                    </div>
                                </button>
                                <button class="btn btn-secondary btn-sm ml-10">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Secondary        
                                    </div>
                                </button>
                                <button class="btn btn-info btn-sm ml-10">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Info        
                                    </div>
                                </button>
                                <button class="btn btn-warning btn-sm ml-10">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Warning        
                                    </div>
                                </button>
                                <button class="btn btn-danger btn-sm ml-10">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Danger        
                                    </div>
                                </button>
                                <button class="btn btn-success btn-sm ml-10">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Success        
                                    </div>
                                </button>
                                <button class="btn btn-dark btn-sm ml-10">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Dark        
                                    </div>
                                </button>
                                <button class="btn btn-disabled btn-sm ml-10">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Disabled        
                                    </div>
                                </button>
                                <button class="btn btn-white btn-sm ml-10">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />White        
                                    </div>
                                </button>
                            </div>

                            <h6 className="mt-4">Icon Button Size: btn-me</h6>
                            <div className="d-flex gap-10">
                                <button class="btn btn-primary btn-me">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Primary        
                                    </div>
                                </button>
                                <button class="btn btn-secondary btn-me ml-10">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Secondary        
                                    </div>
                                </button>
                                <button class="btn btn-info btn-me ml-10">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Info        
                                    </div>
                                </button>
                                <button class="btn btn-warning btn-me ml-10">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Warning        
                                    </div>
                                </button>
                                <button class="btn btn-danger btn-me ml-10">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Danger        
                                    </div>
                                </button>
                                <button class="btn btn-success btn-me ml-10">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Success        
                                    </div>
                                </button>
                                <button class="btn btn-dark btn-me ml-10">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Dark        
                                    </div>
                                </button>
                                <button class="btn btn-disabled btn-me ml-10">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Disabled        
                                    </div>
                                </button>
                            </div>
                            <div className="d-flex gap-10 mt-3">
                                <button class="btn btn-white btn-me">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />White        
                                    </div>
                                </button>
                            </div>
                            <h6 className="mt-4">Icon Button Size: btn-lg</h6>
                            <div className="d-flex gap-10">
                                <button class="btn btn-primary btn-lg">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Primary        
                                    </div>
                                </button>
                                <button class="btn btn-secondary btn-lg ml-10">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Secondary        
                                    </div>
                                </button>
                                <button class="btn btn-info btn-lg ml-10">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Info        
                                    </div>
                                </button>
                                <button class="btn btn-warning btn-lg ml-10">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Warning        
                                    </div>
                                </button>
                                <button class="btn btn-danger btn-lg ml-10">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Danger        
                                    </div>
                                </button>
                                <button class="btn btn-success btn-lg ml-10">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Success        
                                    </div>
                                </button>
                            </div>
                            <div className="d-flex gap-10">
                                <button class="btn btn-dark btn-lg mt-3">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Dark        
                                    </div>
                                </button>
                                <button class="btn btn-disabled btn-lg mt-3">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />Disabled        
                                    </div>
                                </button>
                                <button class="btn btn-white btn-lg mt-3">
                                    <div className="d-flex gap-10 align-items-center">
                                        <FontAwesomeIcon icon={faUser} className="" />White        
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card-header">
                            <h3 className="h5 mb-0">Button Group Design</h3>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-4 btn_group">
                                    <h6>Button Size: btn-sm</h6>
                                    <button class="btn btn_left btn-sm">Left</button>
                                    <button class="btn btn_middle btn-sm">Middle</button>
                                    <button class="btn btn_right btn-sm">Right</button>
                                </div>
                                <div className="col-lg-4 btn_group">
                                    <h6>Button Size: btn-me</h6>
                                    <button class="btn btn_left btn-me">Left</button>
                                    <button class="btn btn_middle btn-me">Middle</button>
                                    <button class="btn btn_right btn-me">Right</button>
                                </div>
                                <div className="col-lg-4 btn_group">
                                    <h6>Button Size: btn-lg</h6>
                                    <button class="btn btn_left btn-lg">Left</button>
                                    <button class="btn btn_middle btn-lg">Middle</button>
                                    <button class="btn btn_right btn-lg">Right</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card-header">
                            <h3 className="h5 mb-0">Dropdown Button</h3>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-8">
                                    <div class="btn-group">
                                        <button type="button" class="btn btn-primary btn-sm">Dropdown</button>
                                        <button type="button" class="btn btn-primary btn-sm dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                                        <span class="visually-hidden">Toggle Dropdown</span>
                                        </button>
                                        <ul class="dropdown-menu">
                                            <li><a class="dropdown-item" href="#">Today</a></li>
                                            <li><a class="dropdown-item" href="#">This Week</a></li>
                                            <li><a class="dropdown-item" href="#">This Month</a></li>
                                            <li><a class="dropdown-item" href="#">This Year</a></li>
                                            <li><div class="dropdown-divider"></div></li>
                                            <li><a class="dropdown-item" href="#">Yesterday</a></li>
                                            <li><a class="dropdown-item" href="#">Previous Week</a></li>
                                            <li><a class="dropdown-item" href="#">Previous Month</a></li>
                                            <li><a class="dropdown-item" href="#">Previous Year</a></li>
                                            <li><div class="dropdown-divider"></div></li>
                                            <li><a class="dropdown-item" href="#">Custom Date</a></li>
                                        </ul>
                                    </div>
                                    <div class="btn-group ml-10">
                                        <button type="button" class="btn btn-secondary btn-me">Dropdown</button>
                                        <button type="button" class="btn btn-secondary btn-me dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                                        <span class="visually-hidden">Toggle Dropdown</span>
                                        </button>
                                        <ul class="dropdown-menu">
                                        <li><a class="dropdown-item" href="#">Today</a></li>
                                            <li><a class="dropdown-item" href="#">This Week</a></li>
                                            <li><a class="dropdown-item" href="#">This Month</a></li>
                                            <li><a class="dropdown-item" href="#">This Year</a></li>
                                            <li><div class="dropdown-divider"></div></li>
                                            <li><a class="dropdown-item" href="#">Yesterday</a></li>
                                            <li><a class="dropdown-item" href="#">Previous Week</a></li>
                                            <li><a class="dropdown-item" href="#">Previous Month</a></li>
                                            <li><a class="dropdown-item" href="#">Previous Year</a></li>
                                            <li><div class="dropdown-divider"></div></li>
                                            <li><a class="dropdown-item" href="#">Custom Date</a></li>
                                        </ul>
                                    </div>
                                    <div class="btn-group ml-10">
                                        <button type="button" class="btn btn-info btn-lg">Dropdown</button>
                                        <button type="button" class="btn btn-info btn-lg dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                                        <span class="visually-hidden">Toggle Dropdown</span>
                                        </button>
                                        <ul class="dropdown-menu">
                                        <li><a class="dropdown-item" href="#">Today</a></li>
                                            <li><a class="dropdown-item" href="#">This Week</a></li>
                                            <li><a class="dropdown-item" href="#">This Month</a></li>
                                            <li><a class="dropdown-item" href="#">This Year</a></li>
                                            <li><div class="dropdown-divider"></div></li>
                                            <li><a class="dropdown-item" href="#">Yesterday</a></li>
                                            <li><a class="dropdown-item" href="#">Previous Week</a></li>
                                            <li><a class="dropdown-item" href="#">Previous Month</a></li>
                                            <li><a class="dropdown-item" href="#">Previous Year</a></li>
                                            <li><div class="dropdown-divider"></div></li>
                                            <li><a class="dropdown-item" href="#">Custom Date</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card-header">
                            <h3 className="h5 mb-0">Circle Button</h3>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-6 d-flex gap-2 align-items-center">
                                    <button className="btn btn-primary circle-button-sm">
                                        <FontAwesomeIcon icon={faUser} className="" />
                                    </button>
                                    <button className="btn btn-secondary circle-button-me">
                                        <FontAwesomeIcon icon={faUser} className="" />
                                    </button>
                                    <button className="btn btn-info circle-button-lg">
                                        <FontAwesomeIcon icon={faUser} className="" />
                                    </button>
                                </div>
                                <div className="col-lg-6 d-flex gap-2 align-items-center">
                                    <button className="btn btn-primary square-button-sm">
                                        <FontAwesomeIcon icon={faUser} className="" />
                                    </button>
                                    <button className="btn btn-secondary square-button-me">
                                        <FontAwesomeIcon icon={faUser} className="" />
                                    </button>
                                    <button className="btn btn-info square-button-lg">
                                        <FontAwesomeIcon icon={faUser} className="" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card-header">
                            <h3 className="h5 mb-0">Toaster Button</h3>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-12">
                                    <Toaster />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Button;